// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GS0j","colBig":"styles_colBig__2eANq","colSmall":"styles_colSmall__1GlJ_"};